export default "/_nuxt/58469318ba2c100ce70874b9558b0708.svg";